/**
 * This script handles opening blox-modals from blox-carousel-item clicks
 * and manages the autoplay state of parent blox-carousels.
 * It is designed to work both on initial page load (DOMContentLoaded) and
 * for dynamically loaded content in Unpoly.
 */
(function() {
    // Key: modalId, Value: { carouselElement: blox-carousel element, hadAutoplay: boolean }
    const carouselAutoplayState = new Map();
    // Flag to prevent re-initialization of event listeners for individual carousel items.
    // Unpoly will re-run compilers, so we need to ensure listeners are only attached once per element.
    const CAROUSEL_ITEM_INITIALIZED_FLAG = 'data-carousel-item-modal-initialized';
    const unpolyAlerts = false; //toggle for unpoly
    /**
     * Initializes a single blox-carousel-item to open a modal and manage carousel autoplay.
     * @param {HTMLElement} item The blox-carousel-item element to initialize.
     */
    function initializeCarouselItemWithModal(item) {
        // Prevent re-initialization if this item has already been processed
        if (item.hasAttribute(CAROUSEL_ITEM_INITIALIZED_FLAG)) {
            return;
        }

        // Add a click event listener to the current carousel item
        item.addEventListener('click', function() {
            // Get the value of the 'modal-id' attribute from the clicked item
            const modalId = this.getAttribute('modal-id');

            // Check if a modalId was found
            if (modalId) {
                // Find the 'blox-modal' element with an id that matches the modalId
                const targetModal = document.getElementById(modalId);

                // Check if the target modal element was found and is a blox-modal
                if (targetModal && targetModal.tagName.toLowerCase() === 'blox-modal') {
                    // Find the closest parent blox-carousel element
                    const parentCarousel = item.closest('blox-carousel');

                    // Check if a parent carousel was found
                    if (parentCarousel) {
                        // Check if the parent carousel has the 'autoplay' attribute
                        const hadAutoplay = parentCarousel.hasAttribute('autoplay');

                        // Store the state if autoplay was present
                        if (hadAutoplay) {
                            carouselAutoplayState.set(modalId, {
                                carouselElement: parentCarousel,
                                hadAutoplay: true
                            });
                            // Remove the autoplay attribute to pause the carousel
                            parentCarousel.removeAttribute('autoplay');
                        } else {
                            // If it didn't have autoplay, ensure no state is stored for this modal.
                            carouselAutoplayState.delete(modalId);
                        }
                    }
                    // Set the 'open' attribute on the target modal to display it
                    targetModal.setAttribute('open', '');
                }
            }
        });

        // Mark the item as initialized
        item.setAttribute(CAROUSEL_ITEM_INITIALIZED_FLAG, 'true');
    }

    // --- Main execution logic for the carousel modal script---
    if (window.up && window.up.version && unpolyAlerts) {
        // Unpoly is available, use up.compiler for robust loading
        up.compiler('blox-carousel-item[has-modal="true"]', function(carouselItem) {
            initializeCarouselItemWithModal(carouselItem);
        });

        // The 'blox-modal-did-hide' event listener only needs to be attached once globally.
        // Unpoly doesn't typically remove global event listeners unless the entire `<body>` is reloaded.
        // We'll add a check to prevent duplicate listeners in case this script is run multiple times globally.
        if (!document.body.hasAttribute('data-blox-modal-hide-listener-attached')) {
            document.addEventListener('blox-modal-did-hide', function(event) {
                const closedModal = event.target;

                if (closedModal && closedModal.tagName.toLowerCase() === 'blox-modal' && closedModal.id) {
                    const modalId = closedModal.id;

                    if (carouselAutoplayState.has(modalId)) {
                        const state = carouselAutoplayState.get(modalId);

                        if (state && state.carouselElement && state.hadAutoplay) {
                            state.carouselElement.setAttribute('autoplay', '');
                            carouselAutoplayState.delete(modalId);
                        } else {
                            carouselAutoplayState.delete(modalId);
                        }
                    }
                }
            });
            document.body.setAttribute('data-blox-modal-hide-listener-attached', 'true');
        }

    } else {
        // Unpoly is not available, fall back to DOMContentLoaded for initial page load
        document.addEventListener('DOMContentLoaded', function() {
            // Select all 'blox-carousel-item' elements that have the 'has-modal' attribute set to "true"
            const carouselItemsWithModal = document.querySelectorAll('blox-carousel-item[has-modal="true"]');

            // Iterate over each selected carousel item and initialize it
            carouselItemsWithModal.forEach(item => {
                initializeCarouselItemWithModal(item);
            });

            // The 'blox-modal-did-hide' event listener only needs to be attached once globally.
            // This is already within DOMContentLoaded, so it runs only once.
            document.addEventListener('blox-modal-did-hide', function(event) {
                const closedModal = event.target;

                if (closedModal && closedModal.tagName.toLowerCase() === 'blox-modal' && closedModal.id) {
                    const modalId = closedModal.id;

                    if (carouselAutoplayState.has(modalId)) {
                        const state = carouselAutoplayState.get(modalId);

                        if (state && state.carouselElement && state.hadAutoplay) {
                            state.carouselElement.setAttribute('autoplay', '');
                            carouselAutoplayState.delete(modalId);
                        } else {
                            carouselAutoplayState.delete(modalId);
                        }
                    }
                }
            });
        });
    }
})();